import styled from 'styled-components'
import { VerticalStyledScrollBar } from '~/styles'

export const Container = styled.div`
  height: 85%;
`

export const ContainerHeader = styled.div`
  width: 100%;
`
export const EmptyMessage = styled.span`
  margin-top: 8px;
  font: normal normal normal 14px/17px Inter;
  color: ${props => props.theme.colors.color6b7786};
`

export const MainHealthProcedureDetailsContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`

export const SurgeryContent = styled.div.attrs(props => ({
  scrollbarBackground: props.theme.zds.colors.neutral1000
}))`
  display: flex;
  flex: 1;
  flex-direction: column;
  height: 100%;
  overflow: auto;

  ${VerticalStyledScrollBar}
`
